import { webConstants as baseConstants } from '../web.constants'

const constants = {

};

export const webConstants = Object.assign(constants, baseConstants)
